module.exports = __webpack_public_path__ + "img/식품_old.f1125bff.png";